export const formatHoursMinutes = (
  totalSeconds: number | null | undefined
): string => {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  if (s <= 0) return '0 minutes';

  let hours = Math.floor(s / 3600);
  let minutes = Math.floor((s % 3600) / 60);

  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  // If there are no whole hours or minutes, show zero minutes
  if (hours === 0 && minutes === 0) return '0 minutes';

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
  if (minutes > 0)
    parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);
  return parts.join(' ');
};

export default formatHoursMinutes;
